/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs */

const en_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunking, retrieval and permission model design.`)
};

const ar_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصميم التقطيع والاسترجاع ونموذج الأذونات.`)
};

const bn_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চাঙ্কিং, রিট্রিভাল আর অনুমতি মডেল ডিজাইন।`)
};

const de_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunking-, Retrieval- und Berechtigungsmodell-Design.`)
};

const es_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño de fragmentación, recuperación y modelo de permisos.`)
};

const fr_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conception du découpage, de la récupération et du modèle de permissions.`)
};

const pt_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenho de fragmentação, recuperação e modelo de permissões.`)
};

const zh_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切分、检索和权限模型设计。`)
};

const tr_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parçalama, getirme ve yetki modeli tasarımı.`)
};

const ru_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проектирование чанкинга, поиска и модели прав.`)
};

const pl_svc_rag_knowledge_assistants_architect_detail9 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt chunkingu, wyszukiwania i modelu uprawnień.`)
};

/**
* | output |
* | --- |
* | "Chunking, retrieval and permission model design." |
*
* @param {Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_architect_detail9 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_architect_detail9(inputs)
	return en_svc_rag_knowledge_assistants_architect_detail9(inputs)
});
export { svc_rag_knowledge_assistants_architect_detail9 as "svc_rag-knowledge-assistants_ARCHITECT_detail" }